export interface ToolbarPatient {
  patientId: string;
  nhsNumber: string;
  firstName: string;
  surname: string;
  dateOfBirth: string;
  status: number;
}

export interface GetPatientFail {
  status: number;
}

export const FETCHING = 'FETCHING' as const;

export function isToolbarPatient(patient: unknown): patient is ToolbarPatient {
  return !!(patient && (patient as ToolbarPatient).patientId);
}

export function isGetPatientFail(patient: unknown): patient is GetPatientFail {
  return !!(patient && (patient as GetPatientFail).status);
}

export function isFetching(patient: unknown): patient is typeof FETCHING {
  return patient === FETCHING;
}
